/**
 * The `scope` a flag surface hands `useFlagRead`: one key for every value its query is made of, so
 * a change to any of them reads as a new scope.
 *
 * Every flag read is made for the active practice, so the practice always leads. A surface that
 * narrows further — one client's chart, or a page of clients — passes what it narrows by as `subject`.
 *
 * @param practiceId - Organization logical id the read is made for
 * @param subject - What the read narrows the practice to, when it narrows at all
 */
export function buildFlagReadScope(practiceId: string, subject?: string): string {
  return subject === undefined ? practiceId : `${practiceId}/${subject}`;
}
